module.exports = __webpack_public_path__ + "img/carryon.22c00736.png";